import React, {useRef} from 'react';

import {Button, Icon, Text} from '@albert-io/atomic';
import {useAnnotationModeStore} from 'client/components/PracticeView/Annotations/AnnotationModeStore';
import {useAnnotationModeEscape} from 'client/components/PracticeView/Annotations/useAnnotationModeEscape';
import {useIsSubjectPracticeAnnotationAvailable} from 'client/SubjectPracticeView/useIsSubjectPracticeAnnotationAvailable';

/** Labelled rather than icon-only: every other control in this toolbar is a text button. */
export default function SubjectAnnotationModeToggle() {
  const toggleButtonRef = useRef<HTMLButtonElement>(null);
  const isAvailable = useIsSubjectPracticeAnnotationAvailable();
  const isAnnotationModeOn = useAnnotationModeStore((state) => state.isAnnotationModeOn);
  const toggleAnnotationMode = useAnnotationModeStore((state) => state.toggleAnnotationMode);
  useAnnotationModeEscape(toggleButtonRef);

  if (!isAvailable) {
    return null;
  }

  return (
    <Button
      ref={toggleButtonRef}
      aria-pressed={isAnnotationModeOn}
      color={isAnnotationModeOn ? 'primary' : 'secondary'}
      data-testid='subject-practice-view__annotation-mode-toggle'
      onClick={toggleAnnotationMode}
      roundness='pill'
      size='s'
      variant={isAnnotationModeOn ? 'solid' : 'text'}
    >
      <Icon icon='highlighter' iconStyle='regular' className='mr-x1' />
      <Text bold size='s' color='inherit'>
        Highlight &amp; Note
      </Text>
    </Button>
  );
}
